export const isPhoneNumber = (value: any) => {
  const phoneNumberRegex =
    /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i
  return phoneNumberRegex.test(value)
}

export default isPhoneNumber
